module.exports = __webpack_public_path__ + "static/media/480.05e8b07c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-rock/dark/480.png
// module id = 2374
// module chunks = 2